import React from "react";
import css from "./index.module.scss";
import DefaultLayout from "layouts/default";
import AuthorTerms from "sections/authorTerms";

export default function RefundPolicyPage() {
  return <DefaultLayout
    description="Submission guidelines."
    title="Submission Guidelines | Lazy Prompts"
  >
    <section className={css.legalese}>
      <div className="sectionInner">
        <AuthorTerms/>
      </div>
    </section>

  </DefaultLayout>;
}

